module.exports = __webpack_public_path__ + "img/avantage1.0dc06eb8.png";